class VariantPicker extends HTMLElement {
  constructor() {
    super();
    this.options       = this.querySelectorAll('.js-option');
    this.data          = JSON.parse(this.querySelector('script[type="application/json"]').textContent);
    this.variantInput  = this.closest('.product-block').querySelector('input[name="id"]');
    this.linkButton    = this.closest('.product-block').querySelector('.variant-link-button');
    this.section       = this.closest('.js-product');
    this.price         = null; // sera initialisé dans updatePrice()

    this.options.forEach(select =>
      select.addEventListener('change', () => this.updateVariant())
    );

    this.updateVariant(); // Initial
  }

  getSelectedOptions() {
    return Array.from(this.options).map(s => s.value.trim());
  }

  updateVariant() {
    const selectedOptions = this.getSelectedOptions();

    // 1. On cherche la variante correspondant aux options sélectionnées
    const found = this.data.product.variants.find(v =>
      v.options.every((opt, idx) => opt === selectedOptions[idx])
    );

    if (found) {
      // 2. On stocke la variante et on met à jour input+lien
      this.variant = found;
      this.variantInput.value = found.id;
      this.linkButton.href   = `/products/${this.data.product.handle}?variant=${found.id}`;
    }

    // 3. On met à jour le prix avec la variante fraîchement stockée
    this.updatePrice();
  }

 updatePrice() {
  if (!this.price)
    this.price = this.section.querySelector('.product-info__price > .price');
  if (!this.price || !this.variant || !this.data.product.formatted) return;

  const fmt = this.data.product.formatted[String(this.variant.id)];
  if (!fmt) {
    console.warn('⚠️ Aucun prix trouvé pour la variante :', this.variant.id);
    return;
  }

  const currEl = this.price.querySelector('.price__current');
  const wasEl = this.price.querySelector('.price__was');
  const unitPrice = this.price.querySelector('.unit-price');

  currEl.innerHTML = fmt.price;
  if (wasEl) wasEl.innerHTML = fmt.compareAtPrice || '';

  if (this.variant.unit_price_measurement) {
    const valueEl = this.price.querySelector('.unit-price__price');
    const unitEl = this.price.querySelector('.unit-price__unit');
    const { reference_value: v, reference_unit: u } = this.variant.unit_price_measurement;

    valueEl.innerHTML = fmt.unitPrice;
    unitEl.textContent = v === 1 ? u : `${v} ${u}`;
    unitPrice.hidden = false;
  } else {
    unitPrice.hidden = true;
  }

  this.price.classList.toggle(
    'price--on-sale',
    this.variant.compare_at_price > this.variant.price
  );
  this.price.classList.toggle('price--sold-out', !this.variant.available);
}

}

customElements.define('variant-picker', VariantPicker);
